module.exports = __webpack_public_path__ + "static/img/1.54428e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/1/1.png
// module id = XDey
// module chunks = 1